// extracted by mini-css-extract-plugin
module.exports = {"overlay":"loading_overlay__1EyR3","opacity":"loading_opacity__2Nz5N"};